import PublicTraceability from './PublicTraceability';

/**
 * Ruta PÚBLICA (sin autenticación) de la trazabilidad de un certificado de
 * circularidad. Es la URL única que se imprime con QR en el PDF del certificado.
 */
const PublicTraceabilityConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/trazabilidad/:serial',
			component: PublicTraceability
		}
	]
};

export default PublicTraceabilityConfig;
